export * from './hub-page.module';
export * from './hub-page.routes';